import { Text, InputSelectControlField } from '@sequencehq/core-components'
import { ComponentProps } from 'react'
import { SeatBasedProrationStrategy } from 'common/drawers/PricingEditor/domain'
import { GreyGrey60, Primary13Regular } from '@sequencehq/core-components'

export const seatProrationLabels: Record<SeatBasedProrationStrategy, string> = {
  USE_MAXIMUM: 'No proration (charge full amount)',
  PRORATE_INCREMENTS: 'Added seats only',
  PRORATE_ALL_CHANGES: 'Added and removed seats'
}

const prorationStrategyOptions: {
  value: SeatBasedProrationStrategy
  label: string
}[] = [
  {
    value: 'USE_MAXIMUM',
    label: seatProrationLabels['USE_MAXIMUM']
  },
  {
    value: 'PRORATE_INCREMENTS',
    label: seatProrationLabels['PRORATE_INCREMENTS']
  },
  {
    value: 'PRORATE_ALL_CHANGES',
    label: seatProrationLabels['PRORATE_ALL_CHANGES']
  }
]

const descriptionByValue: Record<SeatBasedProrationStrategy, string> = {
  USE_MAXIMUM:
    'Charge the full amount for seats added mid-billing period. Removed seats are not refunded.',
  PRORATE_INCREMENTS:
    'Charge a prorated overage fee for seats added mid-billing period. Removed seats are not refunded.',
  PRORATE_ALL_CHANGES:
    'Charge a prorated overage fee for seats added mid-billing period. Removed seats are refunded pro-rata.'
}

type Props = Pick<
  ComponentProps<typeof InputSelectControlField>,
  'validationErrors'
> & {
  value: SeatBasedProrationStrategy
  disabled: boolean
  onChange: (value: SeatBasedProrationStrategy) => void
}

const SeatProrationDropdown = ({
  value,
  onChange,
  disabled,
  ...selectFieldProps
}: Props) => {
  return (
    <InputSelectControlField
      label="Proration"
      disabled={disabled}
      placeholder="Select seat proration"
      options={prorationStrategyOptions}
      value={value}
      onChange={selectedValue =>
        onChange(selectedValue as SeatBasedProrationStrategy)
      }
      description={descriptionByValue[value]}
      {...selectFieldProps}
    />
  )
}

export default SeatProrationDropdown
